export default "__VITE_ASSET__Db7JtI0V__"